import styled from "styled-components";

export const Wrapper = styled.div`
  iframe {
    min-height: 100vh;
  }
`;
